import { render, staticRenderFns } from "./infoRight.vue?vue&type=template&id=d86725e8&"
import script from "./infoRight.vue?vue&type=script&lang=ts&"
export * from "./infoRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports